import { useEffect, useState } from "react";
import { toast } from "sonner";
import { useOrg } from "./org";

const KEEP = [{ v: 30, l: "30 days" }, { v: 90, l: "90 days" }, { v: 365, l: "1 year" }, { v: 0, l: "Until deleted" }];

export const VoiceSettings = () => {
  const { api, membership } = useOrg();
  const [s, setS] = useState(null);
  useEffect(() => { api("/voice-settings").then(setS).catch(() => {}); }, [api]);
  if (!s || membership.role !== "owner") return null;
  const save = (n) => api("/voice-settings", { method: "PUT", body: n }).then((r) => { setS(r); toast.success("Voice Notes settings saved"); }).catch((e) => toast.error(e.message));
  return (
    <section className="mt-16" data-testid="voice-settings">
      <h2 className="t-heading">Voice Notes</h2>
      <p className="t-lead mt-2">Leaders can record a voice memo of up to 2 minutes when they log care. Recordings are encrypted, and only people who can see that care record can play them.</p>
      <label className="flex items-start gap-3 mt-6 cursor-pointer">
        <input type="checkbox" checked={s.ai_enabled} onChange={() => save({ ...s, ai_enabled: !s.ai_enabled, ai_confidential: s.ai_enabled ? false : s.ai_confidential })} className="w-5 h-5 mt-1 accent-[var(--moss)]" data-testid="voice-ai-toggle" />
        <span><span className="t-body font-medium block">Transcribe and summarize with AI</span>
          <span className="t-meta block mt-1">Audio is sent to OpenAI through Emergent's AI gateway to transcribe it and suggest a short summary and next steps. OpenAI says it doesn't train its models on API data and may keep it for up to 30 days for abuse monitoring. Leaders approve every summary and suggestion before anything is saved.</span></span>
      </label>
      {s.ai_enabled && (
        <label className="flex items-start gap-3 mt-4 cursor-pointer">
          <input type="checkbox" checked={s.ai_confidential} onChange={() => save({ ...s, ai_confidential: !s.ai_confidential })} className="w-5 h-5 mt-1 accent-[var(--moss)]" data-testid="voice-ai-confidential-toggle" />
          <span><span className="t-body font-medium block">Also use AI for confidential voice notes</span><span className="t-meta block mt-1">Off by default. When it's off, confidential recordings are only saved, never sent for transcription.</span></span>
        </label>
      )}
      <p className="t-meta mt-6">Keep original audio for</p>
      <div className="flex flex-wrap gap-2 mt-2">
        {KEEP.map((k) => <button key={k.v} aria-pressed={s.retention_days === k.v} onClick={() => save({ ...s, retention_days: k.v })} className="choice h-11 px-4" data-testid={`voice-retention-${k.v}`}>{k.l}</button>)}
      </div>
      <p className="t-meta mt-2">After this, the audio is removed automatically. The care note and transcript stay. Only the Owner can delete a recording and its transcript earlier.</p>
    </section>
  );
};
